module.exports = __webpack_public_path__ + "img/某CRM团队的流失用户预测模型.28c728e7.png";